export default "__VITE_ASSET__BdDTx$rH__"